import { render } from "./TMDBConnection.vue?vue&type=template&id=668d3084&scoped=true"
import script from "./TMDBConnection.vue?vue&type=script&lang=js"
export * from "./TMDBConnection.vue?vue&type=script&lang=js"

import "./TMDBConnection.vue?vue&type=style&index=0&id=668d3084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668d3084"]])

export default __exports__